export default __webpack_public_path__ + "static/media/20.e639572f.png";